import { render, staticRenderFns } from "./medicament.vue?vue&type=template&id=0e92ba9a&"
import script from "./medicament.vue?vue&type=script&lang=js&"
export * from "./medicament.vue?vue&type=script&lang=js&"
import style0 from "./medicament.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports